
import Vue from 'vue';
// @ts-ignore
import PublicPortfolioRequestTestimonialSuccessModalQuery from './apollo/PublicPortfolioRequestTestimonialSuccessModal.gql';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoCheckboxV3 from '~/components/common/BravadoCheckboxV3/BravadoCheckboxV3.vue';
import PublicPortfolioSuccessModal from '~/components/partials/public-portfolio/PublicPortfolioSuccessModal.vue';

type PublicPortfolioRequestTestimonialSuccessModalData = {
  shouldInviteContacts: boolean;
  currentUser: {
    lastContactsSyncedAt: string;
  };
};

export default Vue.extend({
  name: 'PublicPortfolioRequestTestimonialSuccessModal',
  components: { PublicPortfolioSuccessModal, BravadoCheckboxV3, BravadoButtonV3 },
  apollo: {
    currentUser: {
      query: PublicPortfolioRequestTestimonialSuccessModalQuery,
    },
  },
  data(): PublicPortfolioRequestTestimonialSuccessModalData {
    return {
      shouldInviteContacts: true,
      currentUser: {
        lastContactsSyncedAt: '',
      },
    };
  },
  methods: {
    async onDoneClick(): Promise<void> {
      if (this.shouldInviteContacts) {
        await this.$router.push(`?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_CONNECT_MODAL}`);
      } else {
        this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_REQUEST_TESTIMONIAL_SUCCESS_MODAL);
      }
    },
  },
});
